import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

export default ({ width = 72 }) => {
    const data = useStaticQuery(graphql`
        query {
            file(relativePath: { eq: "logotype_light.png" }) {
                childImageSharp {
                    fixed {
                        ...GatsbyImageSharpFixed_noBase64
                    }
                }
            }
        }
    `);

    return (
        <div css={{
            height: "100%",
            width,
        }}>
            <Img
                fixed={ data.file.childImageSharp.fixed }
                style={{
                    height: "100%",
                    width: "100%",
                }}
                imgStyle={{
                    width: "auto",
                    height: "100%",
                    objectFit: "contain",
                }}
            />
        </div>
    );
};
